export const COFMockData = [
    {
        "Network": "Infant Nutrition",
        "actual_cost_saving": '80%'
    },
    {
        "Network": "Health Science Nutrition",
        "actual_cost_saving": '80%'
    },
    {
        "Network": "Nestle Coffee partners",
        "actual_cost_saving": '90%'
    },
    {
        "Network": "Sweet Earth",
        "actual_cost_saving": '80%'
    }
];

export const RedeployCost = [
    {
        "Name": "UF INF FORMULA WIC",
        "BookedAppointments": "800",
        "AvailableAppointments": 1297,
        "Utilization": 200.680801850424054
    },
    {
        "Name": "UF INF FORMULA WIC",
        "BookedAppointments": "756",
        "AvailableAppointments": 1291,
        "Utilization": 200.55925639039504
    },
    {
        "Name": "UF INF FORMULA WIC",
        "BookedAppointments": "668",
        "AvailableAppointments": 1288,
        "Utilization": 300.86335403726708
    },
    {
        "Name": "UF INF FORMULA WIC",
        "BookedAppointments": "584",
        "AvailableAppointments": 1200,
        "Utilization": 300.666666666666664
    },
    {
        "Name": "UF INF FORMULA WIC",
        "BookedAppointments": "224",
        "AvailableAppointments": 592.2,
        "Utilization": 200.825059101654844
    },
];


export const UserDetails = {
    "AccessDetails": [
        {
            "FunctionName": "SNO",
            "ModuleName": "DOM",
            "AccessLevel": "L1",
            "AccessType": "Admin",
            "DefaultPage": false
        },
        {
            "FunctionName": "SNO",
            "ModuleName": "Rapid Response",
            "AccessLevel": "L1",
            "AccessType": "Admin",
            "DefaultPage": false
        },
        {
            "FunctionName": "SNO",
            "ModuleName": "SNO",
            "AccessLevel": "L1",
            "AccessType": "Admin",
            "DefaultPage": false
        },
        {
            "FunctionName": "Deployment Planning",
            "ModuleName": "Deployment Optimization",
            "AccessLevel": "L1",
            "AccessType": "User",
            "DefaultPage": false
        },
        {
            "FunctionName": "Distribution Planning",
            "ModuleName": "Capacity Planning",
            "AccessLevel": "L1",
            "AccessType": "User",
            "DefaultPage": false
        }
    ],
    "loginLogOutDetails": [
        {
            "LoginTime": "2024-11-06T10:56:42.167Z",
            "LogoutTime": "2024-10-25T13:17:55.740Z",
            "LastViewPage": null,
            "LastFilterID": null
        }
    ]
};